import Layout from "@/components/Layout";
import Seo from "@/components/Seo";
import Hero from "@/components/sections/Hero";
import BrandMarquee from "@/components/sections/BrandMarquee";
import Stats from "@/components/sections/Stats";
import Services from "@/components/sections/Services";
import QuickQuote from "@/components/sections/QuickQuote";
import Process from "@/components/sections/Process";
import Testimonials from "@/components/sections/Testimonials";
import PartnerSection from "@/components/sections/PartnerSection";
import Faq from "@/components/sections/Faq";
import ContactSection from "@/components/sections/ContactSection";
import { HOME_FAQ, SITE } from "@/data/site";

export default function Home() {
  return (
    <Layout>
      <Seo
        title="Chiptuning & Schlüsseldienst Cloppenburg | KeyMaster KFZ"
        description="KeyMaster KFZ – dein mobiler Spezialist für Chiptuning, Softwareoptimierung, Steuergerät-Reparatur, Wegfahrsperre, Schlüsseldienst, Notöffnung, Codierungen & KFZ-Schlüssel im Raum Cloppenburg. 24/7, fair & schnell."
        path="/"
        keywords={["Chiptuning Cloppenburg", "Schlüsseldienst Cloppenburg", "Autoschlüssel nachmachen", "KFZ Notöffnung Cloppenburg", "Steuergerät Reparatur"]}
      />
      <Hero />
      <BrandMarquee />
      <Stats />
      <Services />
      <QuickQuote />
      <Process />
      <Testimonials />
      <PartnerSection />
      <Faq
        items={HOME_FAQ}
        title="Häufige Fragen"
        subtitle={`Alles Wichtige rund um unseren Service im Raum ${SITE.address.city}.`}
      />
      <ContactSection />
    </Layout>
  );
}
